// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zoAB","colBig":"styles_colBig__38Bh5","colSmall":"styles_colSmall__BEoCN"};